module.exports = __webpack_public_path__ + "static/media/zones.6aeab717.svg";